import React from 'react';
import { Box } from 'vindi-ds-components';

import Card from '@components/card';
import tokens from 'vindi-ds-tokens';

const CardsChargesPending = ({ listingData }) => (
  <Box
    display='flex'
    flexDirection={{ xs: 'column', md: 'row' }}
    gap={2}
    mt={5}
  >
    <Box width={{ xs: '100%', md: '280px' }}>
      <Card
        title='Cobranças vencidas'
        description={listingData?.send || ''}
        color={tokens.color.prsm.feedback.error[800].value}
      />
    </Box>

    <Box width={{ xs: '100%', md: '325px' }}>
      <Card
        title='Valor total em cobranças vencidas'
        description={listingData?.total || ''}
        color={tokens.color.prsm.feedback.error[800].value}
        currency
      />
    </Box>
  </Box>
);
export default CardsChargesPending;
